import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import FlowButton from './FlowButton';

function NextExerciseButton ({onClick}) {
    
    return <FlowButton className='baseElementsconfirmButton' onClick={onClick} name={"Prossimo Esercizio"}></FlowButton>
}

export default NextExerciseButton;